import { del, get, post } from "../api";

export async function getRentalDrafts() {
    return await get("rental-drafts");
}

export async function getRentalDraft(publicId) {
    return await get(`rental-drafts/${publicId}`);
}

export async function saveRentalDraft(payload) {
    return await post(payload, "rental-drafts");
}

export async function deleteRentalDraft(publicId) {
    return await del(`rental-drafts/${publicId}`);
}
